import React from "react";
import Modal from "react-bootstrap/Modal";
import { isDefined } from "../../utils/utils";
import I18n from "i18n-js";


const AlertPopup = ({
  showAlertPopup,
  onSuccess,
  onCancel,
  onExit,
  onDiscard,
  popupTitle,
  popupContent,
  customHtmlPopupContent,
  cancelButtonText,
  confirmButtonText,
  exitButtonText
}) => {

  // Funzione che gestisce la chiusura del popup
  const handleClose = () => {
    if (onDiscard)
      onDiscard(false);
  }

  // Funzione che gestisce il click sul tasto Conferma del popup
  const handleConfirm = () => {
    if (onSuccess)
      onSuccess();
    handleClose();
  }


  return (
    <Modal show={showAlertPopup} onHide={handleClose} animation={false} size="lg" centered>
      <Modal.Body>
        <div className="font-jost px-4 py-2">
          {
            isDefined(popupTitle) &&
              <div className="border-bottom-aiBlue-2px mb-4">
                <h4 className="mb-1">
                  <b>
                    {popupTitle}
                  </b>
                </h4>
              </div>
          }

          {

            customHtmlPopupContent ?
              <div className="mx-3" dangerouslySetInnerHTML={{ __html: customHtmlPopupContent }}></div>
              :
              <div>{popupContent}</div>
          }

          <div className="d-flex justify-content-between w-100 mx-0 mt-5">
            {
              exitButtonText && onExit &&
              <div>
                <button
                  type="button"
                  className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={onExit}>
                  {exitButtonText}
                </button>
              </div>
            }

            <div>
              {cancelButtonText &&
                <button
                  type="button"
                  className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={onCancel ? () => onCancel() : handleClose}>
                  {cancelButtonText}
                </button>
              }
            </div>

            <div>
              <button
                type="button"
                className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                onClick={handleConfirm}>
                {confirmButtonText}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AlertPopup;